import { createStyles, makeStyles } from "@material-ui/core";
import { useFontSize } from "../context/FontSizeContext";
import { borderBottom } from "@material-ui/system";
const useStyles = makeStyles((theme) =>
  createStyles({
    "@global": {
      "*": {
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
        // fontSize: (props) => `${1 * props.fontSizeMultiplier}rem`,
      },
      html: {
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        height: "100%",
        width: "100%",
      },
      body: {
        backgroundColor: "#ffffff",
        height: "100%",
        width: "100%",
      },
      a: {
        textDecoration: "none",
      },
      "#root": {
        height: "100%",
        width: "100%",
      },
      ".text-left": {
        textAlign: "left !important",
      },
      ".text-center": {
        textAlign: "center !important",
      },
      ".text-right": {
        textAlign: "right !important",
      },
      ".text-break": {
        wordWrap: "break-word!important",
        wordBreak: "break-word!important",
      },
      ".text-wordWrap": {
        wordWrap: "break-word!important",
      },
      ".text-wordBreak": {
        wordBreak: "break-word!important",
      },
      ".text-lowercase": {
        textTransform: "lowercase !important",
      },
      ".text-uppercase": {
        textTransform: "uppercase !important",
      },
      ".text-capitalize": {
        textTransform: "capitalize!important",
      },
      ".text-danger": {
        color: "#dc3545 !important",
      },
      ".text-warning": {
        color: "#ffc107 !important",
      },
      ".text-success": {
        color: "#198754 !important",
      },
      ".bg-danger": {
        backgroundColor: "#dc3545 !important",
      },
      ".bg-warning": {
        backgroundColor: "##ffc107 !important",
      },
      ".swal-button": {
        backgroundColor: theme.UpdateTheme.button_color,
        color: theme.UpdateTheme.text_color,
        "&:hover": {
          backgroundColor: `${theme.UpdateTheme.button_color} !important`,
        },
      },
      ".swal-button--confirm": {
        border: `1px solid ${theme.UpdateTheme.button_color} !important`,
      },
      ".swal-button--cancel": {
        color: "#555 !important",
        "&:hover": {
          backgroundColor: `${theme.UpdateTheme.text_color} !important`,
        },
      },
      ".swal-icon--warning": {
        borderColor: `${theme.UpdateTheme.button_color} !important`,
      },
      ".swal-icon--warning__body, .swal-icon--warning__dot": {
        backgroundColor: `${theme.UpdateTheme.button_color}`,
      },
      ".theme_link": {
        color: `${theme.UpdateTheme.link_color} !important`,
      },
      ".chrome-picker .flexbox-fix div:nth-child(2) div:nth-child(2)": {
        display: " none",
      },
      ".theme_button_text": {
        color: `${theme.UpdateTheme.text_color} !important`,
      },
      ".theme_button_bg": {
        color: `${theme.UpdateTheme.button_color} !important`,
      },
      ".theme_heading": {
        color: `${theme.UpdateTheme.heading_color} !important`,
      },
      ".theme_color": {
        color: `${theme.UpdateTheme.theme_color} !important`,
      },
      ".MuiPickersToolbar-toolbar, .MuiPickersDay-daySelected, .MuiPickerDTTabs-tabs, .MuiPickersClock-pin, .MuiPickersClockPointer-thumb, .MuiPickersClockPointer-pointer, .MuiPickersClockNumber-clockNumberSelected":
        {
          backgroundColor: `${theme.UpdateTheme.button_color} !important`,
        },
      ".theme_table_head_bg": {
        backgroundColor: `${theme.UpdateTheme.table_head_color} !important`,
        color: `${theme.UpdateTheme.button_color} !important`,
        "& th": {
          color: `${theme.UpdateTheme.text_color} !important`,
        },
      },
      ".text-white": {
        color: "#fff !important",
      },
      ".float-left": {
        float: "left !important",
      },
      ".float-right": {
        float: "right !important",
      },
      ".pl-15": {
        paddingLeft: "15px !important",
      },
      ".h-100": {
        height: "100% !important",
      },
      ".w-100": {
        width: "100% !important",
      },
      ".editor-tagstyles ol": {
        margin: " 10px 0px 10px 20px !important",
      },
      ".editor-tagstyles ul": {
        margin: " 10px 0px 10px 20px !important",
      },
      ".page-wrap": {
        padding: "0px 20px",
      },
      ".page-head": {
        color: `${theme.UpdateTheme.heading_color}`,
        marginBottom: "10px !important",
        fontSize: (props) => `${22 * props.fontSizeMultiplier}px !important`,
      },
      ".page-sub-head": {
        color: `${theme.UpdateTheme.heading_color} !important`,
        marginBottom: "10px !important",
        fontSize: (props) => `${20 * props.fontSizeMultiplier}px !important`,
        fontWeight: "500",
      },
      ".MuiListItem-root.Mui-selected": {
        //".MuiListItem-root.Mui-selected:hover":
        backgroundColor: `${theme.UpdateTheme.button_color} !important`,
        color: `${theme.UpdateTheme.text_color} !important`,
        "&:hover": {
          backgroundColor: `${theme.UpdateTheme.button_color} !important`,
        },
      },
      ".disable-btn": {
        color: "#8c8c8c !important",
      },
      ".white-btn": {
        backgroundColor: "#ffffff",
      },
      ".editor-tagstyles": {
        "& ol": {
          margin: " 10px 0px 10px 20px !important",
        },
        "& ul": {
          margin: " 10px 0px 10px 20px !important",
        },
      },
      ".rbc-current-time-indicator": {
        //backgroundColor: `${theme.UpdateTheme.button_color} !important`,
        height: "2px !important",
      },
      ".ck-content .image>figcaption": {
        display: "none !important",
      },

      ".ck-powered-by__label": {
        display: "none",
      },
      ".ck.ck-powered-by": {
        display: "none",
      },
      ".mb-10": {
        marginBottom: "10px",
      },
      ".ck-imagesize img": {
        maxWidth: "225px",
        maxHeight: "150px",
        width: "100%",
        height: "auto",
        objectFit: "contain",
        objectPosition: "left",
        marginTop: "10px",
      },
      ".ck-imagesize-sc img": {
        width: "100%",
        height: "auto",
        objectFit: "contain",
        objectPosition: "left",
        marginTop: "10px",
      },
      ".no-scroll": {
        overflow: "hidden !important",
      },
      ".max-w": {
        maxWidth: "130px !important",
        // color: `${theme.UpdateTheme.heading_color} !important`,
      },
      ".c-pointer": {
        cursor: "pointer !important",
      },
      ".swal-title": {
        textTransform: "none",
      },
      ".discussion_img": {
        "& img": {
          display: "none",
        },
      },
      ".MuiButton-root": {
        textTransform: "capitalize",
      },
      ".btn": {
        backgroundColor: theme.UpdateTheme.button_color,
        color: theme.UpdateTheme.text_color,
        borderRadius: "25px",
      },
      ".btn-def": {
        backgroundColor: "#efefef",
        color: "#333",
        borderRadius: "25px",
      },
      ".btn:hover": {
        backgroundColor: theme.UpdateTheme.button_color,
        color: theme.UpdateTheme.text_color,
      },
      ".socialWall .btn": {
        backgroundColor: theme.UpdateTheme.button_color,
        color: theme.UpdateTheme.text_color,
        borderRadius: "25px",
      },
      ".notallowed": {
        cursor: "not-allowed !important",
      },
      ".ag-cell-focus": {
        borderColor: "transparent !important",
      },
      ".ag-header-cell-text": {
        color: theme.UpdateTheme.text_color,
      },
      ".ag-icon": {
        color: theme.UpdateTheme.text_color,
      },
      ".img-responsive": {
        maxWidth: "100%",
        height: "auto",
      },
      ".bg-published": {
        backgroundColor: "#e2f1e2",
      },
      ".bg-draft": {
        backgroundColor: "#efefef",
      },
      ".text-approve": {
        color: "green !important",
      },
      ".text-reject": {
        color: "red !important",
      },
      ".text-limit": {
        color: "#000",
        fontSize: "12px",
      },
      ".back-btn": {
        cursor: "pointer",
        color: theme.UpdateTheme.link_color,
        marginBottom: "5px",
      },
      ".back-btn .back-btn-text": {
        fontSize: (props) => `${12 * props.fontSizeMultiplier}px`,
      },
      ".all-center": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      },
      ".loaderContainer": {
        position: "fixed",
        zIndex: 99999,
        height: "100%",
        width: "100%",
        overflow: "show",
        margin: "auto",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        background: "radial-gradient(rgba(20, 20, 20,.8), rgba(0, 0, 0, .8))",
      },
      ".dashtablecell": {
        backgroundColor: "rgb(251, 251, 255) !important",
        borderBottom: "none !important",
        marginBottom: "5px",
        //background: "rgb(251, 251, 255)",
        borderRight: "1px solid rgb(239, 239, 239)",
        borderBottom: "none",
        padding: "10px",
      },
      ".dashtablerow": {
        borderBottom: "6px solid #fff",
        borderTop: "none",
      },
      ".bg-dash": {
        background: "rgb(251, 251, 255)",
        backgroundColor:  "rgb(251, 251, 255) !important",
      },
      ".rbc-today": {
        backgroundColor: "#efefef !important",
      },
      "#calendar_wrap .rbc-toolbar button" :{
        color : "#333",
      }
    },
  })
);

const GlobalStyles = () => {
  const { fontSizeMultiplier } = useFontSize();
  useStyles({ fontSizeMultiplier });
  return null;
};

export default GlobalStyles;
